import { buildColMeta, useTableSearch } from '@/components/custom/erp/data-table-v2';
import { BASE_COLS } from '../cols-definition';
import { TABLE_PAGE_SIZE } from '../constants';
import { SearchFormValues } from '../schema';
import { QUERY_KEYS } from '@/constants';

interface UseSearchTableProps {
  searchData: (filters: SearchFormValues, page?: number, searchPageSize?: number) => Promise<void>;
  searchParams: SearchFormValues;
  setSearchParams: (params: SearchFormValues) => void;
  isFiltered: boolean;
  handlePageChange: (page: number) => Promise<void>;
}

export const useSearchTable = ({
  searchData,
  searchParams,
  setSearchParams,
  isFiltered,
  handlePageChange
}: UseSearchTableProps) => {
  return useTableSearch<SearchFormValues>({
    endpoint: `${QUERY_KEYS.PHIEU_XUAT_KHO}/filter`,
    pageSize: TABLE_PAGE_SIZE,
    sumField: 't_tien_nt',
    searchData,
    searchParams,
    setSearchParams,
    isFiltered,
    handlePageChange,
    getColumnMeta: () => buildColMeta(BASE_COLS)
  });
};
